import React from 'react';

import SummaryStatGroupCard from '~components/SummaryStatGroupCard';

import { GocardlessSignupStats } from '~direct-debits/models';

interface ComponentProps {
  stats?: GocardlessSignupStats;
  isLoading?: boolean;
}

const SignupStatsCards: React.FC<ComponentProps> = ({ stats, isLoading = false }) => {
  const safe: GocardlessSignupStats = stats ?? {
    total_clients: 0,
    active_mandates: 0,
    pending_mandates: 0,
    no_mandate: 0,
  };

  const cell = (value: number) => (isLoading ? '—' : value);

  const tiles = [
    { value: cell(safe.total_clients), label: 'Total Clients', className: 'text-primary' },
    { value: cell(safe.active_mandates), label: 'Active Mandates', className: 'text-success' },
    { value: cell(safe.pending_mandates), label: 'Pending Mandates', className: 'text-warning' },
    { value: cell(safe.no_mandate), label: 'No Mandate', className: 'text-secondary' },
  ];

  return (
    <div className="mt-2 mb-3" data-cy="dd-client-signups-stats">
      <SummaryStatGroupCard stats={tiles} />
    </div>
  );
};

export default SignupStatsCards;
